export default "__VITE_ASSET__1fDPeaoH__"